<template>
  <div class="login-page">
    <!-- 动态背景 -->
    <div class="animated-background">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="circle circle-5"></div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-container fade-in">
      <!-- 平台标题 -->
<!--      <div class="platform-title">-->
<!--        <div class="logo-icon">-->
<!--          <i class="el-icon-s-goods"></i>-->
<!--        </div>-->
<!--        <h1>供需发布平台</h1>-->
<!--        <p>连接供需，共创商机</p>-->
<!--      </div>-->

      <!-- 登录卡片 -->
      <div class="login-card glass-effect">
        <div class="card-header">
          <h2>欢迎登录</h2>
          <p>Welcome Login</p>
        </div>

        <!-- 登录方式切换 -->
        <div class="login-tabs">
          <span :class="['tab-item', loginMode === 'password' ? 'active' : '']" @click="switchMode('password')">密码登录</span>
          <span :class="['tab-item', loginMode === 'sms' ? 'active' : '']" @click="switchMode('sms')">短信登录</span>
        </div>

        <!-- 密码登录 -->
        <el-form v-if="loginMode === 'password'" :model="form" ref="loginForm" class="login-form">
          <el-form-item>
            <el-input 
              v-model="form.phone" 
              prefix-icon="el-icon-mobile-phone" 
              placeholder="请输入手机号"
              size="large"
              clearable>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-input 
              type="password" 
              v-model="form.password" 
              prefix-icon="el-icon-lock" 
              placeholder="请输入密码"
              size="large"
              show-password
              @keyup.enter.native="login">
            </el-input>
          </el-form-item>

          <el-form-item>
            <div class="captcha-row">
              <el-input 
                v-model="form.captcha" 
                prefix-icon="el-icon-picture" 
                placeholder="请输入验证码"
                size="large"
                maxlength="4"
                @keyup.enter.native="login"
                class="captcha-input">
              </el-input>
              <img 
                :src="captchaUrl" 
                @click="refreshCaptcha" 
                class="captcha-image"
                alt="验证码"
                title="点击刷新验证码">
            </div>
          </el-form-item>

          <el-form-item>
            <el-button 
              type="primary" 
              @click="login" 
              :loading="loading"
              class="login-btn"
              size="large">
              <span v-if="!loading">立即登录</span>
              <span v-else>登录中...</span>
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 短信登录 -->
        <el-form v-else :model="smsForm" ref="smsLoginForm" class="login-form">
          <el-form-item>
            <el-input
              v-model="smsForm.phone"
              prefix-icon="el-icon-mobile-phone"
              placeholder="请输入手机号"
              size="large"
              clearable>
            </el-input>
          </el-form-item>

          <el-form-item>
            <div class="captcha-row">
              <el-input
                v-model="smsForm.code"
                prefix-icon="el-icon-message"
                placeholder="请输入短信验证码"
                size="large"
                maxlength="6"
                @keyup.enter.native="loginBySms"
                class="captcha-input">
              </el-input>
              <el-button
                :disabled="smsCountdown > 0"
                @click="sendSmsCode"
                :loading="smsSending"
                class="send-code-btn">
                {{ smsCountdown > 0 ? `${smsCountdown}s后重发` : '获取验证码' }}
              </el-button>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="loginBySms"
              :loading="loading"
              class="login-btn"
              size="large">
              <span v-if="!loading">立即登录</span>
              <span v-else>登录中...</span>
            </el-button>
          </el-form-item>
        </el-form>

        <div class="login-footer">
          <span>还没账号？</span>
          <router-link to="/register" class="register-link">
            立即注册 <i class="el-icon-arrow-right"></i>
          </router-link>
        </div>
      </div>

      <!-- 底部信息 -->
<!--      <div class="page-footer">-->
<!--        <p>© 2025 数海领航 供需发布平台 - 让商业更简单</p>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { getCaptchaUrl } from '@/config/api';

export default {
  name: "Login",
  data() {
    return {
      loginMode: 'password',
      form: {
        phone: '',
        password: '',
        captcha: '',
        role: 'USER'
      },
      smsForm: {
        phone: '',
        code: ''
      },
      loading: false,
      captchaKey: '',
      captchaUrl: '',
      smsSending: false,
      smsCountdown: 0,
      smsTimer: null
    }
  },
  mounted() {
    this.refreshCaptcha();
  },
  beforeDestroy() {
    if (this.smsTimer) clearInterval(this.smsTimer);
  },
  methods: {
    switchMode(mode) {
      this.loginMode = mode;
    },

    // 刷新验证码
    refreshCaptcha() {
      this.captchaKey = 'captcha_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      this.captchaUrl = getCaptchaUrl(this.captchaKey);
    },

    // 发送短信验证码
    sendSmsCode() {
      if (!this.smsForm.phone) {
        this.$message.warning('请输入手机号');
        return;
      }
      this.smsSending = true;
      request.post('/user/send-code', null, {
        params: { phone: this.smsForm.phone, type: 'login' }
      }).then(res => {
        if (res.code === '200') {
          this.$message.success('验证码已发送');
          this.smsCountdown = 60;
          this.smsTimer = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer);
              this.smsTimer = null;
            }
          }, 1000);
        } else {
          this.$message.error(res.msg || '发送失败');
        }
      }).catch(() => {
        this.$message.error('发送失败，请稍后重试');
      }).finally(() => {
        this.smsSending = false;
      });
    },

    // 短信登录
    loginBySms() {
      if (!this.smsForm.phone) {
        this.$message.warning('请输入手机号');
        return;
      }
      if (!this.smsForm.code) {
        this.$message.warning('请输入验证码');
        return;
      }
      this.loading = true;
      request.post('/user/login-sms', null, {
        params: { phone: this.smsForm.phone, code: this.smsForm.code }
      }).then(res => {
        if (res.code === '200') {
          this.$message({ message: '登录成功，欢迎回来！', type: 'success', duration: 2000 });
          localStorage.setItem('user', JSON.stringify(res.data));
          setTimeout(() => { this.$router.push('/'); }, 1000);
        } else {
          this.$message.error(res.msg || '登录失败');
        }
      }).catch(() => {
        this.$message.error('网络错误，请稍后重试');
      }).finally(() => {
        this.loading = false;
      });
    },
    
    login() {
      // 简单验证
      if (!this.form.phone) {
        this.$message.warning('请输入手机号');
        return;
      }
      if (!this.form.password) {
        this.$message.warning('请输入密码');
        return;
      }
      if (!this.form.captcha) {
        this.$message.warning('请输入验证码');
        return;
      }

      // 先验证验证码
      this.loading = true;
      request.post('/captcha/verify', null, {
        params: {
          key: this.captchaKey,
          code: this.form.captcha
        }
      }).then(res => {
        if (res.code === '200') {
          // 验证码正确，继续登录
          this.doLogin();
        } else {
          this.$message.error(res.msg || '验证码错误');
          this.refreshCaptcha();
          this.form.captcha = '';
          this.loading = false;
        }
      }).catch(error => {
        this.$message.error('验证码验证失败');
        this.refreshCaptcha();
        this.form.captcha = '';
        this.loading = false;
      });
    },
    
    doLogin() {
      request.post('/user/login', this.form).then(res => {
        if (res.code === '200') {
          this.$message({
            message: '登录成功，欢迎回来！',
            type: "success",
            duration: 2000
          });
          localStorage.setItem("user", JSON.stringify(res.data));
          
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            this.$router.push("/");
          }, 1000);
        } else {
          this.$message({
            message: res.msg || '登录失败，请检查手机号和密码',
            type: 'error'
          });
          this.refreshCaptcha();
          this.form.captcha = '';
        }
      }).catch(error => {
        this.$message.error('网络错误，请稍后重试');
        this.refreshCaptcha();
        this.form.captcha = '';
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 50px;
  overflow: hidden;
  background-image: url('@/assets/svg/供需.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 动态背景动画 */
.animated-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 20s infinite ease-in-out;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-duration: 18s;
}

.circle-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  left: 70%;
  animation-duration: 22s;
  animation-delay: -5s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 30%;
  left: 80%;
  animation-duration: 25s;
  animation-delay: -10s;
}

.circle-4 {
  width: 250px;
  height: 250px;
  top: 70%;
  left: 20%;
  animation-duration: 20s;
  animation-delay: -15s;
}

.circle-5 {
  width: 180px;
  height: 180px;
  top: 40%;
  left: 40%;
  animation-duration: 23s;
  animation-delay: -8s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translate(50px, 50px) scale(1.1);
    opacity: 0.5;
  }
}

/* 登录容器 */
.login-container {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

/* 平台标题 */
.platform-title {
  text-align: center;
  margin-bottom: 30px;
  color: white;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.logo-icon {
  font-size: 60px;
  margin-bottom: 15px;
  animation: pulse 2s infinite;
}

.platform-title h1 {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 10px 0;
  letter-spacing: 2px;
}

.platform-title p {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* 登录方式切换 */
.login-tabs {
  display: flex;
  margin-bottom: 28px;
  border-bottom: 2px solid #e8e8e8;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding-bottom: 12px;
  font-size: 15px;
  color: #999;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.tab-item.active {
  color: #667eea;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 20%;
  width: 60%;
  height: 2px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 2px;
}

/* 获取验证码按钮 */
.send-code-btn {
  flex-shrink: 0;
  height: 50px;
  border-radius: 12px;
  font-size: 13px;
  white-space: nowrap;
  padding: 0 14px;
  border: 2px solid #667eea;
  color: #667eea;
  background: transparent;
  transition: all 0.3s;
}

.send-code-btn:hover:not(:disabled) {
  background: #667eea;
  color: #fff;
}

.send-code-btn:disabled {
  border-color: #ddd;
  color: #bbb;
}

/* 登录卡片 */
.login-card {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.card-header {
  text-align: center;
  margin-bottom: 35px;
}

.card-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.card-header p {
  color: #999;
  font-size: 14px;
  margin: 0;
}

/* 表单样式 */
.login-form {
  margin-top: 0;
}

.login-form >>> .el-input__inner {
  border-radius: 12px;
  height: 50px;
  line-height: 50px;
  border: 2px solid #e8e8e8;
  transition: all 0.3s;
}

.login-form >>> .el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.login-form >>> .el-input__icon {
  line-height: 50px;
}

.login-form .el-form-item {
  margin-bottom: 24px;
}

/* 验证码行 */
.captcha-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 50px;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #e8e8e8;
  transition: all 0.3s;
  flex-shrink: 0;
}

.captcha-image:hover {
  border-color: var(--primary-color);
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.login-btn:active {
  transform: translateY(0);
}

/* 登录底部 */
.login-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.register-link {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
  margin-left: 8px;
  transition: all 0.3s;
}

.register-link:hover {
  color: var(--primary-light);
  transform: translateX(3px);
  display: inline-block;
}

/* 页面底部 */
.page-footer {
  text-align: center;
  margin-top: 30px;
  color: white;
  font-size: 13px;
  opacity: 0.8;
}

/* 渐入动画 */
.fade-in {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-page {
    justify-content: center;
    padding-right: 0;
  }

  .login-container {
    padding: 15px;
  }

  .platform-title h1 {
    font-size: 28px;
  }

  .login-card {
    padding: 30px 20px;
  }

  .logo-icon {
    font-size: 50px;
  }
}
</style>
